export class ArticleModel {
  constructor(
    public _id: string,
    public title: string,
    public content: string) {
  }
}
